<template>
  <div class="me-wrap">
    <div class="info">
      <div class="imgs"><img :src="user.avatar" alt=""></div>
      <div class="names">
        <p class="name">{{user.nickname}}</p>
        <p class="number">用户名：{{user.mobile}}</p>
      </div>
      <div class="set" v-if="user.realname == ''" @click="goToSet">设置名字
        <van-icon name="arrow" class="arrow" />
      </div>
    </div>
    <div class="login-out" @click="goLoginOut" v-if="!inweixin">退出登录</div>
    <div class="call">
      <van-icon name="phone-o" /> <span>联系客服 <a :href="`tel:${user.customer_phone}`">{{user.customer_phone}}</a></span>
    </div>
    <DownApp></DownApp>
  </div>
</template>
<script>
import DownApp from "../../components/downApp/downApp";
import { inWeixin } from "../../common/js/util";
import { mapState } from "vuex";
import axios from "../../http";
export default {
  name: "me",
  components: {
    DownApp,
  },
  props: {},
  data() {
    return {
      inweixin: inWeixin(),
      user: "",
    };
  },
  computed: {
    //userData 用户数据信息
    ...mapState(["token", "userName"]),
  },
  watch: {
    userName() {
      this.getUserInfo();
    },
  },
  mounted() {
    this.getUserInfo();
  },
  destroyed() {},
  methods: {
    getUserInfo() {
      axios
        .fetchPost("/member/center/member", { token: this.token })
        .then((res) => {
          let data = res.data;
          if (data.data.user_type != 1) {
            this.$router.replace({
              path: "/notFarmer",
            });
            return;
          }
          if (data.code == 200) {
            this.user = data.data;
          }
        });
    },
    goLoginOut() {
      //推出登录
      this.$dialog
        .confirm({
          message: "确定要退出登录吗",
        })
        .then(() => {
          // on confirm
          this.$router.push({ path: "/" });
        })
        .catch(() => {
          // on cancel
        });
    },
    goToSet() {
      this.$router.push({
        path: "/setName",
        query: { name: this.user.nickname },
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.me-wrap
  .info
    height 100px
    background #fff
    margin-top 10px
    display flex
    align-items center
    .imgs
      width 50px
      height 50px
      margin 0 15px 0 13px
      background #55CC99
      border-radius 50%
      overflow hidden
      img
        display block
        width 100%
        height 100%
    .names
      flex 1
      text-align left
      .name
        color #282828
        font-size 17px
      .number
        color #999999
        font-size 14px
    .set
      width 90px
      padding-right 13px
      font-size 12px
      font-family Microsoft YaHei
      font-weight 400
      color rgba(153, 153, 153, 1)
      text-align right
      .arrow
        vertical-align middle
        margin-top -1px
  .call
    position absolute
    bottom 20%
    left 0
    right 0
    font-size 14px
    font-family Microsoft YaHei
    font-weight 400
    color rgba(153, 153, 153, 1)
    &>i
      vertical-align middle
      font-size 20px
    & > span
      display inline-block
      vertical-align middle
      & > a
        display inline-block
        vertical-align middle
        color rgba(153, 153, 153, 1)
  .login-out
    margin-top 10px
    background #fff
    height 50px
    line-height 50px
    font-size 15px
    font-family Microsoft YaHei
    font-weight 400
    color rgba(255, 153, 34, 1)
</style>
